<template>
    <div class="c-o-hero" v-lazy-bg-image="hero.image.sizes.section_bg">
        <div class="c-o-hero__content">
            <h1 class="c-o-hero__title" v-html="hero.title"></h1>
            <div class="c-o-hero__body" v-html="hero.body"></div>
            <button-link :label="hero.link.title" :link="hero.link.url" :modifiers="'c-a-button--theme-secondary'"></button-link>
        </div>
    </div>
</template>
<script>
    import ButtonLink from '../atoms/AtomButtonLink.vue';
    export default {
        components: {
            ButtonLink
        },
        props: [
            'hero'
        ],
        computed: {
            backgroundStyle: function() {
                if(this.hero.image.sizes.section_bg) {
                    return `url(${this.hero.image.sizes.section_bg})`;
                }
                return ''
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/OrganismHeroHomeCompany.vue